/**
 * useNavigatorSystem
 */

import { ref } from "vue";
import systemTools from "@/utils/platform";

export const useNavigatorSystem = () => {
    const isMobile = ref<boolean>(systemTools.isMobile());

    return {
        isMobile,
    };
};
